import type { WidgetDefinition } from "@nexus/widget-sdk";
import widgetModule, { TITLE_VARIABLES } from ".";
import { settings } from "./settings";

export const definition: WidgetDefinition = {
  id: "piracy-audience-country",
  module: widgetModule,
  catalog: {
    description:
      "One country's IPTV and Web audience, disruption and coverage; place one per country to build a mosaic.",
    domain: "audience",
    visual: "KPI",
    purposes: ["reporting"],
    audiences: ["analyst", "client"],
  },
  // A tile that spreads over its row: on a dashboard fitted to the screen, rows of
  // country tiles share the free height and their figures grow with them.
  layout: { kind: "content", skeleton: "kpi", rowAlignment: "stretch" },
  settings,
  titleVariables: TITLE_VARIABLES,
  defaultLayoutClassName: "col-span-12 md:col-span-6 xl:col-span-3",
};
